import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Caricamento...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Redirect to accept terms if not accepted
  if (!user.acceptedTerms && window.location.pathname !== '/accept-terms') {
    return <Navigate to="/accept-terms" />;
  }

  return children;
};

export default PrivateRoute;
